import { getRoute, getRouteAssignment, getRouteSettings, getRouteStops, getRouteStudents, getRouteManifest } from '@/apis/route'

const state = {
    details: {},
    assignment: {},
    settings: {},
    stops: [],
    students: [],
    manifest: {},
    pageKey: 'route',
    pageName: 'Route',
    // excludes: 'BusDetailsTracks'
}

const mutations = {
    SET_DETAILS: (state, details) => {
        state.details = details
    },
    SET_ASSIGNMENT: (state, assignment) => {
        state.assignment = assignment instanceof Array ? {} : assignment
    },
    SET_SETTINGS: (state, settings) => {
        state.settings = settings
    },
    SET_STOPS: (state, stops) => {
        state.stops = stops
    },
    SET_STUDENTS: (state, students) => {
        state.students = students
    },
    SET_MANIFEST: (state, manifest) => {
        state.manifest = manifest
    },
    REMOVE_ALL_DETAILS: (state) => {
        state.details = {}
        state.assignment = {}
        state.settings = {}
        state.stops = []
        state.students = []
        state.manifest = {}
    },
    REMOVE_STOP(state, stop_index) {
        state.stops.splice(stop_index, 1)
    },
}

const actions = {
    getStopsAndStudents({ dispatch }, id) {
        return new Promise((resolve, reject) => {
            const promise1 = dispatch('getStops', id)
            const promise2 = dispatch('getStudents', id)
            Promise.all([promise1, promise2]).then(response => {
                resolve(response)
            }).catch(err => {
                console.log(err)
                reject(err)
            })
        })
    },
    getBaseDetails({ dispatch }, id) {
        return new Promise((resolve, reject) => {
            const promise1 = dispatch('getDetails', id)
            const promise2 = dispatch('getAssignment', id)
            Promise.all([promise1, promise2]).then(response => {
                resolve(response)
            }).catch(err => {
                console.log(err)
                reject(err)
            })
        })
    },
    getDetails({ commit }, id) {
        return new Promise((resolve, reject) => {
            getRoute(id).then(res => {
                const { data } = res
                commit('SET_DETAILS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getAssignment({ commit }, id) {
        return new Promise((resolve, reject) => {
            getRouteAssignment(id).then(res => {
                const { data } = res
                commit('SET_ASSIGNMENT', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getSettings({ commit }, id) {
        return new Promise((resolve, reject) => {
            getRouteSettings(id).then(res => {
                const { data } = res
                commit('SET_SETTINGS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getStops({ commit }, id) {
        return new Promise((resolve, reject) => {
            getRouteStops(id).then(res => {
                const { data } = res
                commit('SET_STOPS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getStudents({ commit }, id) {
        return new Promise((resolve, reject) => {
            getRouteStudents(id).then(res => {
                const { data } = res
                commit('SET_STUDENTS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getManifest({ commit }, {id, date}) {
        return new Promise((resolve, reject) => {
            getRouteManifest(id, date).then(res => {
                const { data } = res
                commit('SET_MANIFEST', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}